import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const AgentPresenceLoader: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgentPresence" */ '../src/AgentPresence/AgentPresence.tsx'
			)
		).AgentPresence,
});
